import { render, staticRenderFns } from "./listGw.vue?vue&type=template&id=2ef101fb"
import script from "./listGw.vue?vue&type=script&lang=js"
export * from "./listGw.vue?vue&type=script&lang=js"
import style0 from "./listGw.vue?vue&type=style&index=0&id=2ef101fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports